import React from 'react';
import './AltLine.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/fontawesome-free-solid';
import { faTrashAlt, faCopy } from '@fortawesome/fontawesome-free-regular';
import RevertableForm from './RevertableForm';
import TextareaAutosize from 'react-autosize-textarea';
import { formatChangedLineValue } from '../utils/lines';

export default class AltLine extends RevertableForm {
  constructor(props, context) {
    super(props, context);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleDuplicate = this.handleDuplicate.bind(this);
  }

  // States are null if unchanges, if there is a value here, they are changed.
  defaultNewObj = {
    text: null,
    syllables: null,
    stresses: null,
  };

  componentDidMount() {
    if (this.props.autoFocus && this.props.obj.text === '') {
      this.textarea.focus();
    }
  }

  // constructor(props) {
  //   super(props);
  //   this.state = { ...this.defaultState };

  //   this.handleInputChange = this.handleInputChange.bind(this);
  //   this.handleDiscard = this.handleDiscard.bind(this);
  //   this.handleSave = this.handleSave.bind(this);
  //   this.handleSaveAs = this.handleSaveAs.bind(this);
  //   this.handleKeyPress = this.handleKeyPress.bind(this);
  //   this.handleDuplicate = this.handleDuplicate.bind(this);
  // }

  // handleInputChange(e) {
  //   let v = e.target.value;

  //   if (e.target.type === 'number') {
  //     v = parseInt(v, 10);
  //     if (isNaN(v)) {
  //       v = null;
  //     } else {
  //       v = Math.max(0, v);
  //     }
  //   }

  //   if (v === this.props.line[e.target.name]) {
  //     v = null;
  //   }

  //   this.setState({
  //     ...this.state,
  //     [e.target.name]: v,
  //   });
  // }

  // handleDiscard() {
  //   this.setState({ ...this.defaultState });
  // }

  // handleSave() {
  //   this.props.onUpdate(this.state);
  //   this.handleDiscard();
  // }

  // handleSaveAs() {
  //   this.props.onCreate(this.state);
  //   this.handleDiscard();
  // }

  // handleKeyPress(e) {
  //   if (e.key === 'Enter') {
  //     this.handleSave();
  //   }
  // }
  formatChangedValue(e) {
    return formatChangedLineValue(e);
  }

  handleDuplicate(e) {
    e.preventDefault();
    this.props.onDuplicate(this.props.line, this.props.index);
  }

  handleSelect(e) {
    e.preventDefault;
    if (this.props.onSelect) this.props.onSelect();
  }

  render() {
    return (
      <tr>
        <td className="pl-2 pt-1 pb-1 pr-1 border-0">
          {this.props.onSelect && (
            <input
              type="radio"
              className="mr-2"
              checked={this.props.selected}
              onChange={this.handleSelect}
            />
          )}
        </td>
        <td className="p-1 border-0">
          <TextareaAutosize
            name="text"
            className="form-control form-control-sm m-0"
            value={this.state.text || this.props.line.text}
            onChange={this.handleChange}
            onKeyPress={this.handleKeyPress}
            rows={1}
            innerRef={(ref) => {
              this.textarea = ref;
            }}
          />
        </td>

        {this.props.uiToggles.syllables && (
          <td className="p-1 border-0">
            <input
              type="number"
              name="syllables"
              className="form-control form-control-sm no-spin-button text-center px-1"
              value={this.state.syllables || this.props.line.syllables || ''}
              placeholder={`${this.props.line.text.split(/[- ]/).length}?`}
              step="1"
              min="0"
              max="99"
              onChange={this.handleChange}
              onKeyPress={this.handleKeyPress}
            />
          </td>
        )}
        {this.props.uiToggles.stresses && (
          <td className="p-1 border-0">
            <input
              type="number"
              name="stresses"
              className="form-control form-control-sm no-spin-button text-center px-1"
              value={this.state.stresses || this.props.line.stresses || ''}
              step="1"
              min="0"
              max="99"
              placeholder="-"
              onChange={this.handleChange}
              onKeyPress={this.handleKeyPress}
            />
          </td>
        )}
        <td className="p-1 border-0" style={{ whiteSpace: 'nowrap' }}>
          <div className="btn-group dropleft">
            <button
              className="btn btn-link btn-sm dropdown-togdgle"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <FontAwesomeIcon
                icon={faEllipsisV}
                className="mr-1"
                // style={{ visibility: isDirty ? 'visible' : 'hidden' }}
              />
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              {this.isDirty() ? (
                <a className="dropdown-item pl-2" href="#revert" onClick={this.handleRevert}>
                  <span style={{ marginRight: '1.375em' }} />Revert changes
                </a>
              ) : (
                <span className="dropdown-item pl-2 text-muted">
                  <span style={{ marginRight: '1.375em' }} />Revert changes
                </span>
              )}
              <div className="dropdown-divider" />

              <a className="dropdown-item pl-2" href="#duplicate" onClick={this.handleDuplicate}>
                <FontAwesomeIcon icon={faCopy} className=" mr-2" />
                Duplicate
              </a>

              {this.props.selected ? (
                <span className="dropdown-item pl-2 text-muted">
                  <span style={{ marginRight: '1.375em' }} />Remove from group
                </span>
              ) : (
                <a className="dropdown-item pl-2" href="#remove" onClick={this.props.onRemove}>
                  <span style={{ marginRight: '1.375em' }} />Remove from group
                </a>
              )}

              {this.props.selected ? (
                <span className="dropdown-item text-muted pl-2">
                  <FontAwesomeIcon icon={faTrashAlt} className="mr-2" />
                  Delete
                </span>
              ) : (
                <a
                  className="dropdown-item text-danger pl-2"
                  href="#delete"
                  onClick={this.props.onDelete}
                >
                  <FontAwesomeIcon icon={faTrashAlt} className="text-danger mr-2" />
                  Delete
                </a>
              )}
            </div>
          </div>
          {/*
          <span title="Discard changes" onClick={this.handleDiscard}>
            <FontAwesomeIcon
              icon={faBan}
              className="text-danger mr-1"
              style={{ visibility: isDirty ? 'visible' : 'hidden' }}
            />
          </span>
          <span title="Save changes to new line" onClick={this.handleSaveAs}>
            <FontAwesomeIcon
              icon={faPlus}
              className="text-primary mr-1"
              style={{ visibility: isDirty ? 'visible' : 'hidden' }}
            />
          </span>
          <span title="Save changes" onClick={this.handleSave}>
            <FontAwesomeIcon
              icon={faCheck}
              className="text-success"
              style={{ visibility: isDirty ? 'visible' : 'hidden' }}
            />
          </span>
          */}
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AltLine.js